import React from 'react';
import WorkItemCard from './WorkItemCard';
import './WorkItemBoard.css';

const WorkItemBoard = ({ workItems, onStatusChange, onEdit, onView, onDelete, totals, canDelete }) => {
  const columns = [
    { id: 'todo', title: 'A Fazer', color: '#f59e0b' },
    { id: 'inProgress', title: 'Em Progresso', color: '#3b82f6' },
    { id: 'done', title: 'Concluído', color: '#10b981' }
  ];

  const handleDragStart = (e, item) => {
    e.dataTransfer.setData('workItem', JSON.stringify(item));
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = (e, status) => {
    e.preventDefault();
    const data = e.dataTransfer.getData('workItem');
    
    if (data) {
      const item = JSON.parse(data);
      
      // Check if item is authorized before allowing status change
      if (!item.authorized && status !== 'todo') {
        alert('Este item precisa ser autorizado pelo cliente antes de poder ser movido para outra coluna.');
        return;
      }
      
      // Prevent moving from 'inProgress' back to 'todo'
      if (item.status === 'inProgress' && status === 'todo') {
        alert('Não é permitido mover itens de "Em Progresso" para "A Fazer".');
        return;
      }
      
      // Check if all items are completed before moving to 'done'
      if (status === 'done') {
        const hasUncompletedServicos = item.selectedServicos?.some(s => !s.completed);
        const hasUncompletedActivities = item.customActivities?.some(a => !a.completed);
        const hasUncompletedReembolsos = item.reembolsos?.some(r => !r.completed);
        
        if (hasUncompletedServicos || hasUncompletedActivities || hasUncompletedReembolsos) {
          alert('Não é possível mover para "Concluído" enquanto houver itens não finalizados.');
          return;
        }
        
        // Also check if there are any items at all
        const totalItems = (item.selectedServicos?.length || 0) + 
                          (item.customActivities?.length || 0) + 
                          (item.reembolsos?.length || 0);
        
        if (totalItems === 0) {
          alert('Não é possível mover para "Concluído" um item sem atividades.');
          return;
        }
      }
      
      if (item.status !== status) {
        onStatusChange(item._id, status);
      }
    }
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value || 0);
  };

  // Calculate consolidated totals per column
  const calculateConsolidatedTotals = () => {
    const consolidatedTotals = {
      todo: 0,
      inProgress: 0,
      done: 0
    };
    
    workItems.forEach(item => {
      if (consolidatedTotals.hasOwnProperty(item.status)) {
        consolidatedTotals[item.status] += item.totalConsolidado || 0;
      }
    });
    
    return consolidatedTotals;
  };

  const consolidatedTotals = calculateConsolidatedTotals();

  return (
    <div className="work-item-board">
      {columns.map(column => {
        const columnItems = workItems.filter(item => item.status === column.id);
        
        return (
          <div 
            key={column.id} 
            className="board-column"
            onDragOver={handleDragOver}
            onDrop={(e) => handleDrop(e, column.id)}
          >
            <div className="column-header">
              <h3 style={{ color: column.color }}>{column.title}</h3>
              <span className="column-count">{columnItems.length}</span>
            </div>
            
            <div className="column-total">
              <div className="total-label">Consolidado: {formatCurrency(consolidatedTotals[column.id])}</div>
              <div className="total-label-secondary">Previsto: {formatCurrency(totals[column.id])}</div>
            </div>
            
            <div className="column-items">
              {columnItems.length === 0 ? (
                <div className="empty-column">
                  <p>Nenhum item</p>
                </div>
              ) : (
                columnItems.map(item => (
                  <WorkItemCard
                    key={item._id}
                    workItem={item}
                    onDragStart={handleDragStart}
                    onEdit={onEdit}
                    onView={onView}
                    onDelete={onDelete}
                    canDelete={canDelete}
                  />
                ))
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default WorkItemBoard;
